module.exports = __webpack_public_path__ + "static/img/check-mark.f2ec482.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottie/check-mark.gif
// module id = 6kHz
// module chunks = 248